import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

// Components
import Media from 'react-media';
import Button from 'components/atoms/Button';

// Actions
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Constants
import { APP_BREAKPOINTS } from 'constants/appConfig';
import { VEHICLE_PROPERTIES, VEHICLE_VALUES } from 'constants/vehicle';

import './VehicleBuilderList.scss';

// Placeholder
import VehicleBuilderListLoader from './VehicleBuilderListLoader';
import LoaderHOC from 'components/atoms/LoaderHOC';

// Utils
import { getSpecialMakeLabel } from 'utils/string';

const ns = 'vehicle-builder-list';
const ct = 'card-text';
const { XS } = APP_BREAKPOINTS;
const { MAKE, MODEL } = VEHICLE_PROPERTIES;

const { OTHER } = VEHICLE_VALUES;

class VehicleBuilderList extends Component {
  onClickItem = (event, data) => {
    const { onSelectionCallback, type, gtmUserEvent } = this.props;
    onSelectionCallback(data, type);
    if (data === OTHER && type === MAKE) {
      gtmUserEvent(
        'OTHER Make Button',
        'Clicked',
        'OTHER Make Selected',
        'GTM_CURRENT_PAGE > Make Section',
        OTHER
      );
    }
  };

  getButtonCmp = (classButton, { data, label }, mobile) => {
    const { intl, type } = this.props;
    const formattedLabel = intl.formatMessage({
      id: 'c8.vehicle.page.other'
    });
    let buttonLabel;
    if (label === 'OTHER') {
      buttonLabel = formattedLabel;
    } else {
      buttonLabel = type === MAKE ? getSpecialMakeLabel(label) : label;
    }
    return (
      <Button
        className={classButton}
        id={type + '-' + data}
        buttonTheme="link"
        onClick={event => this.onClickItem(event, data, mobile)}
      >
        {buttonLabel}
      </Button>
    );
  };

  render() {
    const {
      items,
      itemSelected,
      type,
      serviceId,
      className,
      intl
    } = this.props;
    const classProps = classNames(
      {
        'show-list-anim': items.length > 0,
        [ns]: true
      },
      className
    );
    return (
      <LoaderHOC
        serviceId={serviceId}
        placeHolderType={() => <VehicleBuilderListLoader />}
        component={() => (
          <div className="vehicle-builder__list">
            <div className={classProps}>
              {items.map(item => {
                const classButton = classNames({
                  [`${ns}__${ct} ${item.label} ${ns}__ada`]:
                    itemSelected !== item.data,
                  [`${ns}__${ct}--selected ${item.label} ${ns}__ada`]:
                    itemSelected === item.data
                });
                if (item.label !== OTHER || type === MODEL) {
                  return (
                    <div className={`${ns}__${ct}`} key={item.data}>
                      <Media query={`(max-width: ${XS}px)`}>
                        {matches =>
                          this.getButtonCmp(classButton, item, matches)
                        }
                      </Media>
                    </div>
                  );
                } else {
                  return (
                    <div className={`${ns}__${ct}`} key={item.data}>
                      <p className={`${ns}__other-message`}>
                        {intl.formatMessage({
                          id: 'c8.vehicle.page.do.not.see.your.make'
                        })}
                      </p>
                      {this.getButtonCmp(classButton, item)}
                    </div>
                  );
                }
              })}
            </div>
          </div>
        )}
      />
    );
  }
}

VehicleBuilderList.propTypes = {
  className: PropTypes.string,
  gtmUserEvent: PropTypes.func.isRequired,
  intl: PropTypes.object,
  items: PropTypes.array.isRequired,
  itemSelected: PropTypes.string,
  onSelectionCallback: PropTypes.func.isRequired,
  serviceId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ gtmUserEvent }, dispatch);

export default compose(
  injectIntl,
  connect(
    null,
    mapDispatchToProps
  )
)(VehicleBuilderList);



// WEBPACK FOOTER //
// ./src/components/molecules/VehicleBuilderList/VehicleBuilderList.js